import { render, staticRenderFns } from "./VSacAppMain.vue?vue&type=template&id=567f8dd2"
import script from "./VSacAppMain.vue?vue&type=script&lang=js"
export * from "./VSacAppMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports